import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, ShoppingBag, MessageSquare, Wallet } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function BuyerDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ orders: [], total_spent: 0, custom_requests: [] });

  useEffect(() => {
    api.get("/buyer/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="cw-label">Buyer Dashboard</div>
      <h1 className="font-display text-4xl mt-2">Hey {user?.name?.split(" ")[0]},</h1>

      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        <Stat icon={<ShoppingBag />} label="Scripts purchased" value={stats.orders?.length || 0} />
        <Stat icon={<Wallet />} label="Total spent" value={`₹${stats.total_spent}`} />
        <Stat icon={<MessageSquare />} label="Custom requests" value={stats.custom_requests?.length || 0} />
      </div>

      <section className="mt-10">
        <h2 className="font-display text-2xl mb-4">Purchased scripts</h2>
        {(!stats.orders || stats.orders.length === 0) ? (
          <div className="cw-card rounded-2xl p-10 text-center">
            <p className="text-white/60">No purchases yet.</p>
            <Link to="/marketplace" className="cw-btn-primary inline-block mt-4">Browse Marketplace</Link>
          </div>
        ) : (
          <div className="cw-card rounded-2xl divide-y divide-white/5 overflow-hidden">
            {stats.orders.map((o) => (
              <div key={o.order_id} className="flex items-center justify-between p-4">
                <div>
                  <div className="font-display">{o.script_title}</div>
                  <div className="text-xs text-white/50 mt-1">{new Date(o.created_at).toLocaleDateString()}</div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-white/80">₹{o.amount}</div>
                  <Link to={`/scripts/${o.script_id}`} className="cw-btn-ghost text-sm inline-flex items-center gap-2"><Download className="h-4 w-4" /> View</Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="mt-10">
        <h2 className="font-display text-2xl mb-4">Custom requests</h2>
        {(!stats.custom_requests || stats.custom_requests.length === 0) ? (
          <div className="cw-card rounded-2xl p-6 text-white/60">You haven't submitted a custom request yet. <Link to="/#custom" className="text-[#FF6B00]">Start one</Link></div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {stats.custom_requests.map((r) => (
              <div key={r.request_id} className="cw-card rounded-xl p-5">
                <div className="cw-label">{r.industry}</div>
                <div className="font-display text-lg mt-1">{r.brand_name}</div>
                <p className="text-white/60 text-sm mt-1">{r.goal}</p>
                <div className="text-xs text-white/40 mt-2">Status: {r.status}</div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

function Stat({ icon, label, value }) {
  return (
    <div className="cw-card rounded-2xl p-6">
      <div className="h-9 w-9 rounded-lg bg-[#FF6B00]/15 border border-[#FF6B00]/30 flex items-center justify-center text-[#FF6B00]">{icon}</div>
      <div className="cw-label mt-4">{label}</div>
      <div className="font-display text-3xl mt-1">{value}</div>
    </div>
  );
}
